<div class="contact-form default-block-padding-top">
    <div class="container-fluid">
        <div class="row">
            <div class="offset-lg-3 col-lg-6">
                <div class="title text-center" [innerHTML]="data.title | bypassSecurity"></div>

                <app-dynamic-form [formFields]="data.formFields" [submitButtonText]="data.buttonText" [loading]="loading"
                    (submitted)="onSubmit($event)"></app-dynamic-form>

                    <div class="content text-center mt-4" [innerHTML]="data.content | bypassSecurity"></div>
            </div>
        </div>
    </div>
</div>